import React from 'react';
import { Link } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { useId } from 'react';
import { trackMatomoEvent } from 'services/matomo.service';
import { TbIcon } from 'components/Figma';
import { cn } from 'utils/classNamesTailwind';

interface DrillDownEntryCardProps {
  icon: React.ReactNode;
  labelId: string;
  to: string;
  className?: string;
  testid?: string;
}

export function DrillDownEntryCard({ icon, labelId, to, className = '', testid = '' }: DrillDownEntryCardProps) {
  const intl = useIntl();
  const instanceId = useId();

  const handleClick = () => {
    trackMatomoEvent({
      action: 'DrillDownEntryCard',
      name: {
        defaultNamePrefix: 'drill-down-entry',
        details: [labelId],
        testid,
        instanceId,
      },
      includePageContextInAction: true,
    });
  };

  return (
    <Link
      to={to}
      onClick={handleClick}
      data-testid={testid}
      className={cn(
        'flex items-center gap-2',
        'bg-snow-50 rounded-lg py-6 px-4 col-span-6 xl:col-span-4',
        'cursor-pointer hover:bg-denim-50 hover:shadow-elevation-medium transition duration-200',
        'no-underline',
        className
      )}
    >
      <span className="flex-shrink-0 text-gray-900">{icon}</span>
      <span className="flex-1 text-base font-bold text-gray-900 truncate">{intl.formatMessage({ id: labelId })}</span>
      <TbIcon name="ArrowRight" size="xl" className="flex-shrink-0 text-gray-900" />
    </Link>
  );
}
